import { pathOr } from "ramda";

export const profileImagePath = (profile, colorMode) => pathOr({}, ['relationships', `${colorMode}Photo`, 'relationships', 'field_media_image', 'localFile', 'childImageSharp', 'fluid'], profile);

export const imageHeight = 0.45;
export const imageWidth = 0.29;
export const rowWidth = 0.31;

export const getRowByLength = length => {
	let rows;
	switch (length % 9) {
		case 1:
			rows = 1;
			break;
		case 2:
		case 3:
			rows = 2;
			break;
		case 4:
		case 5:
			rows = 3;
			break;
		case 6:
			rows = 4;
			break;
		case 7:
		case 8:
			rows = 5;
			break;
		case 9:
			rows = 6;
			break;
		default:
			rows = 0;
	}

	return rows + Math.trunc(length / 9) * 6;
};

export const getPositionTop = index => [0.26, 0.08, 0.55, 0, 0.47, 0.29, 0.08, 0.55, 0.35][index % 9];
